import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  Avatar,
  Chip,
} from "@mui/material";
import { AlertTriangle } from "lucide-react";
import { format } from "date-fns";
import "./DialogConflitoHorario.scss";

function DialogConflitoHorario({ open, onClose, conflitos, onConfirmar }) {
  const formatDateTime = (date) => {
    return format(new Date(date), "dd/MM/yyyy HH:mm");
  };

  const getTipoLabel = (tipo) => {
    const labels = {
      Agenda: "Consulta",
      AgendaTratamento: "Tratamento",
      TratamentoIsolado: "Tratamento Isolado",
      Compromisso: "Compromisso",
    };
    return labels[tipo] || tipo;
  };

  const getTipoColor = (tipo) => {
    const colors = {
      Agenda: "primary",
      AgendaTratamento: "secondary",
      TratamentoIsolado: "warning",
      Compromisso: "error",
    };
    return colors[tipo] || "default";
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="dialog-conflito-title">
        <AlertTriangle size={24} color="#ff9800" />
        <span>Conflito de Horário</span>
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning" style={{ marginBottom: "16px" }}>
          O horário selecionado já possui {conflitos.length}{" "}
          {conflitos.length === 1 ? "agendamento" : "agendamentos"}:
        </Alert>

        <div className="conflitos-list">
          {conflitos.map((conflito, index) => (
            <div key={index} className="conflito-item">
              <div className="conflito-header">
                <Chip
                  label={getTipoLabel(conflito.tipo)}
                  size="small"
                  color={getTipoColor(conflito.tipo)}
                />
              </div>

              <div className="conflito-body">
                {conflito.cliente && (
                  <div className="conflito-cliente">
                    <Avatar
                      src={
                        conflito.cliente.foto
                          ? `${process.env.REACT_APP_BACKEND_LINK}/${conflito.cliente.foto}`
                          : "/images/fallBackPicture.png"
                      }
                      alt={conflito.cliente.nome}
                      sx={{ width: 32, height: 32 }}
                    />
                    <strong>{conflito.cliente.nome}</strong>
                  </div>
                )}

                <div className="conflito-info">
                  <div>
                    <strong>Horário:</strong>{" "}
                    {formatDateTime(conflito.data_inicio)} -{" "}
                    {format(new Date(conflito.data_fim), "HH:mm")}
                  </div>
                  <div>
                    <strong>
                      {conflito.tipo === "Compromisso"
                        ? "Descrição"
                        : "Procedimento"}
                      :
                    </strong>{" "}
                    {conflito.descricao}
                  </div>
                  {conflito.avaliacao && (
                    <Chip label="Avaliação" size="small" color="info" />
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <Alert severity="info" style={{ marginTop: "16px" }}>
          Você pode agendar mesmo assim, mas haverá sobreposição de horários.
        </Alert>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button onClick={onConfirmar} variant="contained" color="warning">
          Sim, Agendar Mesmo Assim
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogConflitoHorario;
